module.exports = __webpack_public_path__ + "static/media/Folders2.f0f78941.svg";